/*
|--------------------------------------------------------------------------
| Ads: Amazon APS integration.
|--------------------------------------------------------------------------
*/
/**
 * The apstag header bidding JavaScript library is used to request bids from Amazon Publisher Services’ Transparent Ad Marketplace.
 */
__gh__webApp.ads.amazonHeader = {

	"init": function(){
		debug.log('Amazon ASP init')
		this.loadLibrary();
		this.apsInit();
		this.fetchBaseBids();		
	},
	
	/**
	 * Load APS library 
	 */
	"loadLibrary": function(){
		__gh__webApp.common.loadScript({
			'text'			: '!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function(){q("f",arguments)},setDisplayBids:function(){},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore( A,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");'
		});
	},
	
	/**
	 * initilize APStag  
	 * and have apstag set bids on the googletag slots when they are returned to the page
	 */
	"apsInit": function(){
		apstag.init({
			pubID: 3252, 
			adServer: 'googletag', 
			bidTimeout: 2e3
		});
		
	},
	
	/**
	 * fetchBaseBids APStag  
	 * request the bids for the googletag slots
	 */
	"fetchBaseBids": function(){
		
		try{
			var templateType=__gh__webApp.ads.dfp.config();
				defaultSlotsJSON   = tmplDefinitionsJSON.template[templateType].slotFeed,
				jsonSlotStandard=defaultSlotsJSON.base.slots.standard,
				slotsForBids=[],
				slotCount=0;
			
			if(jsonSlotStandard !== undefined) {
		 
				$.each(jsonSlotStandard, function(slotName, item) {
					var currentId=defaultSlotsJSON.base.slots.standard[slotName].id,
						currentDimensions=[],
						currentDimensionItem=[],
						currentDimentionL=defaultSlotsJSON.base.slots.standard[slotName].dimensions.length,
						jsonDimensions=defaultSlotsJSON.base.slots.standard[slotName].dimensions,
						dcount=0,
						currentMap=undefined,
						currentView=undefined,
						sizeMappings=[];	
						//console.log('slotID='+slotName)
						//console.log('currentId='+currentId)
						slotsForBids[slotCount]={slotID:slotName,sizes:[]}
						//slotsForBids[slotCount].slotID=slotName;
						
					//Mappings    
					currentMap=$('#'+slotName).attr('data-size-mapping');
					if(currentMap!=undefined) {
					    
					    $.each(dfpMaps.map[currentMap], function(view, item) {
						    currentView=dfpMaps.map[currentMap][view];
				    		//Build current slot sizeMapping
						    //debug.info("currentView.ad_sizes="+currentView.ad_sizes);
						    //debug.info("currentView.viewport="+currentView.viewport);
							
							// given a size mapping like: [[[1000, 600], [[300, 250], [300,600]]],[[0,0], [[300,250]]]]
							// return the valid size mapping as an array like: [[300,250]] when the screen dimensions
							// are less than 1000 width and 600 height
							sizeMappings.push([currentView.viewport, currentView.ad_sizes])
						});
						var validMappings=__gh__webApp.utilities.parseSizeMappings(sizeMappings);
						//console.log("sizeMappings=",sizeMappings);
						//console.log("validMappings=",validMappings);
						//console.log("validMappings.length=",validMappings.length);
						validMappings.length > 0 ? slotsForBids[slotCount].sizes=validMappings : slotsForBids.pop();
	
					} 
					else{	
						 //Define Standard Slot Dimensions
					    $.each(jsonDimensions, function(d, ditem) {
						  	currentDimensionItem.push(ditem.size.w)
						  	currentDimensionItem.push(ditem.size.h)
						  	currentDimensions.push(currentDimensionItem);
						  	//console.log(dcount+" currentDimensions= ",currentDimensions[dcount])
						  	//console.log(dcount+" jsonDimensions= ",jsonDimensions[dcount])
						  	slotsForBids[slotCount].sizes.push([ditem.size.w,ditem.size.h]);
						  	dcount+=1;
						  	
					    });
					}    
					   
					
					//__gh__webApp.utilities.parseSizeMappings =function(buildMap)
					//End Mappings
					    
					slotCount+=1; 
				});

				//console.log("base bids slotsForBids= ",slotsForBids)
			}
			
			apstag.fetchBids(
				{ 
				slots: slotsForBids
				},
					function(bids){
						//console.log('base bids',bids);
						__gh__webApp.ads.dfp.init();
				});
		}
		catch(e){
			debug.log("Error fetching Base bids. Error= "+e)
			__gh__webApp.ads.dfp.init();
		}
			
		
	},
	/**
	 * Fetch Lazy Bid
	 */
	"fetchLazyBid": function(slotsForBids,dfpID,slotName){
		try{
			apstag.fetchBids(
			{ 
				slots: slotsForBids
			},
				function(bids){
					apstag.setDisplayBids();
					//console.log("bids",bids);
					// handle bids array then trigger ad server call(s) ...
					//console.log(dfpID+":fetchBids ",dfpID)
					__gh__webApp.ads.dfp.renderSlot(dfpID,slotName);
			});
		}
		catch(e){
			debug.log("Error fetching Lazy bids. Error= "+e)
			__gh__webApp.ads.dfp.renderSlot(dfpID,slotName);
		}
	}

};